import jwtEncode from 'jwt-encode'

export function setCookies(identity: string, provider?: string): void {
  document.cookie = `token=${jwtEncode({ identity }, 'qwert1234@#')};path=/;domain=.guigo.tv;`
  if (provider) {
    let androidAppId = 'com.guigo.android'
    if (provider === 'barinet') androidAppId = 'com.guigo.barinettv'
    else if (provider === 'housenet') androidAppId = 'com.guigo.hntvandroid'
    else if (provider === 'livetv') androidAppId = 'com.guigo.liveint'
    else if (provider === 'msfibra') androidAppId = 'com.guigo.msfibraandroid'
    else if (provider === 'turbolink') androidAppId = 'com.guigo.turbolinkandroid'
    else if (provider === 'webfiber') androidAppId = 'com.guigo.webfiberandroid'
    else if (provider === 'verofamilia') androidAppId = 'com.guigo.veroandroid'
    document.cookie = `android_app_id=${androidAppId};path=/;domain=.guigo.tv;`

    let iosAppId = 'com.guigo.guigotv'
    if (provider === 'barinet') iosAppId = 'com.guigo.barinettv'
    else if (provider === 'housenet') iosAppId = 'com.guigo.hntvappios'
    else if (provider === 'livetv') iosAppId = 'com.guigo.liveinternet'
    else if (provider === 'msfibra') iosAppId = 'com.guigo.msfibraappios'
    else if (provider === 'turbolink') iosAppId = 'com.guigo.turbolinkappios'
    else if (provider === 'webfiber') iosAppId = 'com.guigo.webfiberappios'
    else if (provider === 'verofamilia') iosAppId = 'com.guigo.verofamiliaios'
    document.cookie = `ios_app_id=${iosAppId};path=/;domain=.guigo.tv;`
  }
}

export function redirect(provider?: string): void {
  if (!provider) window.location.href = process.env.REACT_APP_PC_APP_GUIGO as string
  else if (provider === 'barinet') window.location.href = 'https://barinet.guigo.tv'
  else if (provider === 'housenet') window.location.href = 'https://housenet.guigo.tv'
  else if (provider === 'livetv') window.location.href = 'https://livetv.guigo.tv'
  else if (provider === 'msfibra') window.location.href = 'https://msfibra.guigo.tv'
  else if (provider === 'turbolink') window.location.href = 'https://turbolink.guigo.tv'
  else if (provider === 'webfiber') window.location.href = 'https://webfiber.guigo.tv'
  else if (provider === 'allrede') window.location.href = 'https://allrede.guigo.tv'
  else if (provider === 'verofamilia') window.location.href = process.env.REACT_APP_VEROFAMILIA_APP_GUIGO as string
  else window.location.href = process.env.REACT_APP_PC_APP_GUIGO as string
}
